import {
  LegalList,
  LegalPageLayout,
  LegalParagraph,
  LegalSection,
  LegalTable,
} from '@/pages/legal/LegalPageLayout';

export default function CookiesPage() {
  return (
    <LegalPageLayout
      version="Versão 1.1"
      updatedAt="Atualizado em 11/05/2026"
      title="Política de Cookies — Culture Monitor"
    >
      <LegalParagraph>
        Esta Política de Cookies descreve como o Culture Monitor, operado pela{' '}
        <span className="italic">live.</span> (LIVE MARKETING DE DISSEMINACAO LTDA), utiliza
        cookies e tecnologias similares em conformidade com a Lei Geral de Proteção de Dados
        Pessoais (LGPD — Lei nº 13.709/2018) e o Marco Civil da Internet (Lei nº 12.965/2014).
      </LegalParagraph>
      <LegalParagraph>
        Esta política é parte integrante dos Termos de Uso e da Política de Privacidade e
        Proteção de Dados Pessoais.
      </LegalParagraph>

      <LegalSection title="1. Identificação do Controlador">
        <p className="font-semibold text-gray-600">Controlador dos Dados:</p>
        <LegalList
          items={[
            <>
              <strong>Razão Social:</strong> LIVE MARKETING DE DISSEMINACAO LTDA
            </>,
            <>
              <strong>CNPJ:</strong> 07.759.470/0001-82
            </>,
            <>
              <strong>Endereço:</strong> Av. Brig. Faria Lima 1572 — Jardim Paulistano — CEP:
              01451-917 — São Paulo / SP
            </>,
            <>
              <strong>Contato geral:</strong> dpo@culturemonitor.com
            </>,
          ]}
        />
        <p className="font-semibold text-gray-600">Encarregado de Dados (DPO):</p>
        <LegalList
          items={[
            <>
              <strong>Nome:</strong> Lucas Polato
            </>,
            <>
              <strong>E-mail:</strong> dpo@culturemonitor.com
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="2. O Que São Cookies">
        <LegalParagraph>
          Cookies são pequenos arquivos de texto armazenados no seu dispositivo (computador,
          tablet ou celular) quando você acessa um site. Eles são utilizados para garantir o
          funcionamento do site, registrar preferências, medir desempenho e oferecer
          funcionalidades adicionais.
        </LegalParagraph>
        <LegalParagraph>
          Esta política também se aplica a tecnologias similares, como pixels, identificadores de
          dispositivo, armazenamento web (web storage) e fingerprinting, quando utilizados pelo
          Culture Monitor.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="3. Categorias de Cookies Utilizados">
        <LegalParagraph>
          O Culture Monitor utiliza as seguintes categorias de cookies:
        </LegalParagraph>
        <LegalTable
          headers={['Categoria', 'Finalidade', 'Base Legal (LGPD, art. 7º)', 'Consentimento']}
          rows={[
            [
              'Essenciais',
              'Necessários para autenticação, segurança, registro de consentimento e funcionamento básico da plataforma. Sem eles o serviço não opera.',
              'Execução de contrato (art. 7º, V) e legítimo interesse (art. 7º, IX)',
              'Não exigem',
            ],
            [
              'Analíticos',
              'Mensuram uso, comportamento e desempenho da plataforma para fins de melhoria do produto. Coletados via PostHog.',
              'Consentimento (art. 7º, I)',
              'Exigem',
            ],
            [
              'Marketing / Publicidade',
              'Não utilizamos cookies dessa categoria no Culture Monitor.',
              '—',
              '—',
            ],
          ]}
        />
        <LegalParagraph>
          Esclarecemos que o Culture Monitor não utiliza cookies de marketing ou publicidade e não
          cede dados de cookies a redes de anúncios ou parceiros publicitários.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="4. Cookies de Terceiros (Subprocessadores)">
        <LegalParagraph>
          Para operar o Culture Monitor, contamos com fornecedores e parceiros que podem definir
          cookies em nome da <span className="italic">live.</span> Todos atuam como Operadores,
          sob obrigações contratuais de confidencialidade e segurança.
        </LegalParagraph>
        <LegalTable
          headers={['Provedor', 'Categoria', 'Finalidade', 'Política do Provedor']}
          rows={[
            [
              'PostHog',
              'Analítico',
              'Mensuração de comportamento de uso e melhoria do produto',
              'https://posthog.com/privacy',
            ],
            [
              'CookieYes',
              'Essencial',
              'Gestão e registro de consentimento de cookies',
              'https://www.cookieyes.com/privacy-policy/',
            ],
          ]}
        />
      </LegalSection>

      <LegalSection title="5. Lista Detalhada de Cookies">
        <LegalParagraph>
          Abaixo, a relação dos principais cookies utilizados na plataforma:
        </LegalParagraph>
        <LegalTable
          headers={['Nome', 'Provedor', 'Categoria', 'Finalidade', 'Tipo', 'Duração']}
          rows={[
            [
              '(cookie de sessão)',
              'Culture Monitor',
              'Essencial',
              'Manter autenticação do Usuário',
              'HTTP',
              'Sessão',
            ],
            [
              'cookieyes-consent',
              'CookieYes',
              'Essencial',
              'Armazenar preferências de consentimento',
              'HTTP',
              '1 ano',
            ],
            [
              'ph_*_posthog',
              'PostHog',
              'Analítico',
              'Mensurar uso da plataforma',
              'HTTP',
              '1 ano',
            ],
          ]}
        />
        <LegalParagraph>
          O Usuário também pode acessar e alterar suas preferências a qualquer momento pelo painel
          de &quot;Preferências de cookies&quot; disponível no rodapé da plataforma.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="6. Bases Legais para o Uso de Cookies">
        <LegalList
          items={[
            <>
              <strong>Cookies essenciais:</strong> tratados com base na execução de contrato (LGPD,
              art. 7º, V) e legítimo interesse (LGPD, art. 7º, IX), pois são indispensáveis ao
              funcionamento da plataforma (ex.: autenticação do usuário ou manutenção de sessão
              segura).
            </>,
            <>
              <strong>Cookies analíticos:</strong> tratados com base no consentimento (LGPD, art.
              7º, I), coletado de forma livre, informada e granular por meio do banner exibido no
              primeiro acesso.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="7. Como Gerenciar Seu Consentimento">
        <LegalParagraph>
          Você tem controle total sobre cookies não essenciais:
        </LegalParagraph>
        <LegalList
          items={[
            <>
              <strong>Banner de consentimento:</strong> exibido no primeiro acesso, permite
              aceitar ou recusar categorias separadamente.
            </>,
            <>
              <strong>Painel &quot;Preferências de cookies&quot;:</strong> disponível no rodapé da
              plataforma, permite revisar ou alterar suas escolhas a qualquer momento.
            </>,
            <>
              <strong>Configurações do navegador:</strong> você pode bloquear ou excluir cookies
              diretamente no seu navegador.
            </>,
          ]}
        />
        <LegalParagraph>
          A revogação do consentimento não afeta o funcionamento das funcionalidades essenciais,
          mas interrompe a coleta de dados analíticos e não tem efeito retroativo.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="8. Prazos de Retenção dos Cookies">
        <LegalList
          items={[
            <>
              <strong>Cookies de sessão:</strong> expiram automaticamente ao encerrar o navegador.
            </>,
            <>
              <strong>Cookies persistentes:</strong> permanecem armazenados por período
              determinado, em geral entre 30 dias e 24 meses, conforme detalhado na tabela da Seção
              5.
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="9. Transferência Internacional de Dados">
        <LegalParagraph>
          Alguns provedores utilizados, como PostHog e CookieYes, possuem infraestrutura fora do
          Brasil. Nesses casos, a transferência internacional ocorre com fundamento no art. 33 da
          LGPD, observando padrões internacionais de segurança e garantias contratuais adequadas.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="10. Direitos do Titular">
        <LegalParagraph>
          Em conformidade com a LGPD, o Usuário tem direito a:
        </LegalParagraph>
        <LegalList
          items={[
            'Confirmar a existência de tratamento de seus dados pessoais coletados via cookies;',
            'Acessar esses dados;',
            'Corrigir dados incompletos, inexatos ou desatualizados;',
            'Solicitar anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com a lei;',
            'Solicitar a portabilidade dos dados;',
            'Obter informações sobre os subprocessadores envolvidos;',
            'Ser informado sobre a possibilidade de não fornecer consentimento e suas consequências;',
            'Revogar o consentimento, a qualquer tempo;',
            'Solicitar revisão de decisões tomadas unicamente com base em tratamento automatizado, conforme art. 20 da LGPD.',
          ]}
        />
        <LegalParagraph>
          Para exercer qualquer um desses direitos, o Usuário pode entrar em contato com o nosso
          Encarregado de Dados pelo e-mail dpo@culturemonitor.com. Responderemos em até 15 (quinze)
          dias.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="11. Atualizações desta Política">
        <LegalParagraph>
          Esta política é atualizada periodicamente. A versão vigente estará sempre disponível
          nesta página de Política de Cookies.
        </LegalParagraph>
        <LegalParagraph>
          Alterações materiais serão comunicadas por e-mail ou aviso na plataforma com antecedência
          mínima de 15 dias.
        </LegalParagraph>
        <LegalParagraph>
          A lista detalhada de cookies (Seção 5) é atualizada continuamente pela equipe técnica,
          sem aviso prévio.
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="12. Contato">
        <LegalParagraph>
          Para dúvidas, solicitações ou exercício de direitos relacionados a esta Política de
          Cookies:
        </LegalParagraph>
        <LegalList
          items={[
            <>
              <strong>Encarregado de Dados (DPO):</strong> Lucas Polato — dpo@culturemonitor.com
            </>,
            <>
              <strong>Suporte geral:</strong> dpo@culturemonitor.com
            </>,
            <>
              <strong>Autoridade Nacional de Proteção de Dados (ANPD):</strong>{' '}
              https://www.gov.br/anpd
            </>,
          ]}
        />
      </LegalSection>
    </LegalPageLayout>
  );
}
